import * as Form from '../../../components/form'
import * as Request from '../../../request'

export const REPORTS_ONBOARDING_SESSIONS = 'REPORTS_ONBOARDING_SESSIONS'
export const FETCH_ONBOARDING_SESSION = 'FETCH_ONBOARDING_SESSION'
export const FetchOnboardingSession = {
  error: Request.errorConstant(FETCH_ONBOARDING_SESSION),
  request: Request.requestConstant(FETCH_ONBOARDING_SESSION),
  success: Request.successConstant(FETCH_ONBOARDING_SESSION),
}

export const FETCH_ONBOARDING_SESSIONS = 'FETCH_ONBOARDING_SESSIONS'
export const FetchOnboardingSessions = {
  error: Request.errorConstant(FETCH_ONBOARDING_SESSIONS),
  request: Request.requestConstant(FETCH_ONBOARDING_SESSIONS),
  success: Request.successConstant(FETCH_ONBOARDING_SESSIONS),
}

export const FormConstants = Form.createConstantsMap(REPORTS_ONBOARDING_SESSIONS)
export const save = FormConstants.SAVE
export const update = FormConstants.UPDATE



// WEBPACK FOOTER //
// ./src/pages/reports/onboarding-sessions/constants.ts